// Copied from AssetModal/Header/components/AssetModalHeaderTitle.tsx
import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { ASSET_TITLE } from "~/constants/testIDs";
import { centralizedDisplayTitleSelector } from "~/store/centralizedClip/selectors";
export const AssetTitle = /*#__PURE__*/ memo(()=>{
    const title = useSelector(centralizedDisplayTitleSelector);
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full truncate text-16 font-semibold text-grey-12",
        "data-testid": ASSET_TITLE,
        children: title
    });
});
AssetTitle.displayName = "AssetTitle";
